import './CtaSection.css';

export default function CtaSection() {
  return (
    <section className="cta-section section">
      <div className="cta-section__bg" aria-hidden="true" />
      <div className="cta-section__grid-pattern" aria-hidden="true" />

      <div className="container cta-section__inner">
        <div className="cta-section__content">
          <span className="badge badge-brand" style={{ marginBottom: 'var(--space-2)' }}>
            Start Today, It's Free
          </span>
          <h2 className="display-xl cta-section__title">
            Most businesses are losing customers<br />
            <span className="gradient-text">in the DMs.</span>
          </h2>
          <p className="text-xl cta-section__sub">
            Customers message and wait hours, then go to a competitor. Zepliq fixes this with AI that speaks your language, knows your products, and works around the clock.
          </p>

          <div className="cta-section__actions">
            <a href="https://dashboard.zepliq.com" className="btn btn-primary btn-lg cta-section__btn-primary">
              Start Free
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <a href="https://dashboard.zepliq.com" className="btn btn-secondary btn-lg">
              See How It Works
            </a>
          </div>

          <div className="cta-section__trust">
            {['No credit card required', '14-day free trial', 'Setup in 5 minutes', 'Cancel anytime'].map(t => (
              <span key={t} className="cta-section__trust-item">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
